// extracted by mini-css-extract-plugin
module.exports = {"summary":"styles_summary__2lew0","loading":"styles_loading__2b1rp"};